import React, { useContext } from "react";
import { Icon, Title } from "@wdpr/groot-components";
import Link from "components/shared/Link";
import { getCdn, mapString } from "utils";
import { getCurrentDateInSelectedLocale } from "utils/date";
import appConfig from "config.json";
import { Context } from "Context";

const { brands, defaultParkHoursTimeZone } = appConfig;
const moreParkHoursClass = `syndicated-link-groups__list__item--moreParkHours`;

const MoreParkHours = ({
	name,
	description,
	listItemClass,
	titleClass,
	subTitleClass,
	linkClass,
}) => {
	const {
		config: { locale, brand },
	} = useContext(Context);
	const parkHoursTimeZone =
		brands?.[brand]?.defaultParkHoursTimeZone || defaultParkHoursTimeZone;
	return (
		<li className={listItemClass}>
			<div className={`${moreParkHoursClass}__container`}>
				{description.icon && <Icon icon={description.icon} getCdn={getCdn} />}
				<div
					className={`${moreParkHoursClass}__container__content ${moreParkHoursClass}__container__content--${brand}`}
				>
					<Title
						className={titleClass}
						name={name}
						title={mapString(description?.title, "")}
					/>
					{!description.subtitle && (
						<Title
							className={subTitleClass}
							subTitle={`${mapString(
								description?.subtitle,
								""
							)}<span class="${moreParkHoursClass}__container__content__date ${moreParkHoursClass}__container__content__date--${brand} ${moreParkHoursClass}__container__content__date--bold">${getCurrentDateInSelectedLocale(
								parkHoursTimeZone,
								"full",
								locale,
								description?.dateFormat
							)}</span>`}
							name={name}
						/>
					)}
					<Link
						{...description.link}
						className={`${linkClass} ${moreParkHoursClass}__container__content__link ${moreParkHoursClass}__container__content__link--${brand}`}
					>
						<Title title={description?.link?.title} noWrap name={name} />
					</Link>
					{description.subtitle && (
						<Title
							className={subTitleClass}
							subTitle={mapString(
								description?.subtitle,
								`<span class="${moreParkHoursClass}__container__content__date ${moreParkHoursClass}__container__content__date--${brand}">${getCurrentDateInSelectedLocale(
									parkHoursTimeZone,
									"full",
									locale,
									description?.dateFormat
								)}</span>`
							)}
							name={name}
						/>
					)}
				</div>
			</div>
		</li>
	);
};

export default MoreParkHours;
